// extracted by mini-css-extract-plugin
export default {"endorsers":"index_endorsers__2vBbD"};